import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = { class: "card-header card-header-stretch" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("导出Excel")
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "fw-bold" }
const _hoisted_9 = {
  class: "text-muted",
  style: {"font-size":"12px"}
}
const _hoisted_10 = {
  class: "text-muted",
  style: {"font-size":"12px"}
}
const _hoisted_11 = {
  key: 0,
  class: "text-danger",
  style: {"font-size":"12px"}
}
const _hoisted_12 = {
  class: "text-success",
  style: {"font-size":"12px"}
}
const _hoisted_13 = {
  class: "text-muted",
  style: {"font-size":"11px"}
}
const _hoisted_14 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode("预售")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("现货")
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = {
  class: "text-muted",
  style: {"font-size":"11px"}
}
const _hoisted_21 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_22 = /*#__PURE__*/_createTextVNode("详情")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vxe_input = _resolveComponent("vxe-input")!
  const _component_vxe_form_item = _resolveComponent("vxe-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_vxe_button = _resolveComponent("vxe-button")!
  const _component_vxe_form = _resolveComponent("vxe-form")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_vxe_pager = _resolveComponent("vxe-pager")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_vxe_form, {
        data: _ctx.formData,
        onSubmit: _ctx.submitEvent
      }, {
        default: _withCtx(() => [
          _createVNode(_component_vxe_form_item, {
            field: "order_no",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_vxe_input, {
                modelValue: _ctx.formData.order_no,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.order_no) = $event)),
                placeholder: "订单号"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "user_nickname",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_vxe_input, {
                modelValue: _ctx.formData.user_nickname,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.user_nickname) = $event)),
                placeholder: "用户昵称"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "user_mobile",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_vxe_input, {
                modelValue: _ctx.formData.user_mobile,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.user_mobile) = $event)),
                placeholder: "用户手机号"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "product_name",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_vxe_input, {
                modelValue: _ctx.formData.product_name,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.product_name) = $event)),
                placeholder: "商品名称"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "status",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.status,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.status) = $event)),
                placeholder: "订单状态",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "全部",
                    value: ""
                  }),
                  _createVNode(_component_el_option, {
                    label: "待付款",
                    value: "pending_payment"
                  }),
                  _createVNode(_component_el_option, {
                    label: "已付订金",
                    value: "deposit_paid"
                  }),
                  _createVNode(_component_el_option, {
                    label: "待发货",
                    value: "pending_shipment"
                  }),
                  _createVNode(_component_el_option, {
                    label: "已发货",
                    value: "shipped"
                  }),
                  _createVNode(_component_el_option, {
                    label: "已完成",
                    value: "completed"
                  }),
                  _createVNode(_component_el_option, {
                    label: "已取消",
                    value: "cancelled"
                  }),
                  _createVNode(_component_el_option, {
                    label: "已退款",
                    value: "refunded"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "is_presale",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.is_presale,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.is_presale) = $event)),
                placeholder: "商品类型",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "全部",
                    value: ""
                  }),
                  _createVNode(_component_el_option, {
                    label: "现货",
                    value: "false"
                  }),
                  _createVNode(_component_el_option, {
                    label: "预售",
                    value: "true"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_vxe_button, {
                type: "submit",
                status: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_button, {
                type: "button",
                onClick: _ctx.onReset
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_vxe_button, {
                type: "button",
                status: "success",
                onClick: _ctx.onExport
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "onSubmit"])
    ]),
    _createVNode(_component_vxe_table, {
      data: _ctx.tableData,
      "row-config": { isHover: true }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_vxe_column, {
          field: "order_no",
          title: "订单号",
          width: "150"
        }),
        _createVNode(_component_vxe_column, {
          title: "商品信息",
          width: "200"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_6, [
              (row.product_snapshot?.image)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: row.product_snapshot.image,
                    class: "me-2",
                    style: {"width":"40px","height":"40px","object-fit":"cover","border-radius":"4px"}
                  }, null, 8, _hoisted_7))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(row.product_snapshot?.name), 1),
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.formatPrice(row.unit_price)) + " x " + _toDisplayString(row.quantity), 1)
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "用户",
          width: "120"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(row.user?.nickname), 1),
            _createElementVNode("div", _hoisted_10, _toDisplayString(row.user?.mobile), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "金额",
          width: "150"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", null, "原价: " + _toDisplayString(_ctx.formatPrice(row.original_amount)), 1),
            (row.discount_amount && parseFloat(row.discount_amount) > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, " 优惠: -" + _toDisplayString(_ctx.formatPrice(row.discount_amount)), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, "实付: " + _toDisplayString(_ctx.formatPrice(row.total_amount)), 1),
            _createElementVNode("div", _hoisted_12, "已付: " + _toDisplayString(_ctx.formatPrice(row.paid_amount)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "优惠券",
          width: "120"
        }, {
          default: _withCtx(({ row }) => [
            (row.coupon_info)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_el_tag, {
                    size: "small",
                    type: "warning"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(row.coupon_info.name), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(row.coupon_info.discount_text), 1)
                ], 64))
              : (_openBlock(), _createElementBlock("span", _hoisted_14, "-"))
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "类型",
          width: "80"
        }, {
          default: _withCtx(({ row }) => [
            (row.is_presale)
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "warning",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_el_tag, {
                  key: 1,
                  type: "success",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "支付模式",
          width: "80"
        }, {
          default: _withCtx(({ row }) => [
            (row.payment_mode === 'full')
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, "全款"))
              : (row.payment_mode === 'deposit')
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, "订金"))
                : (_openBlock(), _createElementBlock("span", _hoisted_19, "-"))
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "状态",
          width: "100"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_tag, {
              type: _ctx.getStatusType(row.status),
              size: "small"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(row.status_text), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "收货信息",
          width: "180"
        }, {
          default: _withCtx(({ row }) => [
            (row.address_snapshot)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", null, _toDisplayString(row.address_snapshot.name) + " " + _toDisplayString(row.address_snapshot.mobile), 1),
                  _createElementVNode("div", _hoisted_20, _toDisplayString(row.address_snapshot.area), 1)
                ], 64))
              : (_openBlock(), _createElementBlock("span", _hoisted_21, "-"))
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "created_at",
          title: "下单时间",
          width: "160"
        }),
        _createVNode(_component_vxe_column, {
          title: "操作",
          width: "80",
          fixed: "right"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: ($event: any) => (_ctx.$router.push({ name: 'mall_order_edit', params: { id: row.id } }))
            }, {
              default: _withCtx(() => [
                _hoisted_22
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_vxe_pager, {
      "current-page": _ctx.page.currentPage,
      "onUpdate:current-page": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.page.currentPage) = $event)),
      "page-size": _ctx.page.pageSize,
      "onUpdate:page-size": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.page.pageSize) = $event)),
      total: _ctx.page.totalResult,
      layouts: [
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total',
      ],
      onPageChange: _ctx.onPageChange
    }, null, 8, ["current-page", "page-size", "total", "onPageChange"])
  ]))
}